import axios from 'axios';
import { setUserDetails, setLoading, setError } from './userSlice';
import { MAIN_URL } from '../services/MainURLConfig';
import { showToast } from '../components/Common/Toastify';
export const fetchUserData = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    const token = localStorage.getItem('token');
    const response = await axios.get(`${MAIN_URL}/api/users/meta`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log('User meta data:', response.data);
    dispatch(setUserDetails(response.data));
  } catch (error) {
    // dispatch(setError(error.message || 'Failed to fetch user data'));
    const errorMessage = error?.response?.data?.message || '';

    if (errorMessage.includes("JWT expired")) {
      // Optional: clear storage or reset auth state
      localStorage.removeItem('token');
      dispatch(setUserDetails(null)); // if needed

      showToast("error", "Session expired. Redirecting to login...");

      // Redirect to login or home page
      setTimeout(() => {
        window.location.href = "/"; 
      }, 1500);
    } else {
      dispatch(setError(error.message || 'Failed to fetch user data'));
      // showToast("error", "Failed to fetch user data.", error);
    }

  } finally {
    dispatch(setLoading(false));
  }
};
